//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import imageUpload from "components/imageUpload.vue";
export default {
  data: function data() {
    return {
      siteTitle: '',
      province: '',
      city: '',
      userName: '',
      displayName: '',
      avatorUrl: '',
      mobile: '',
      files: [],
      fileList: [],
      MedalIconUrl: '',
      AvatorUrl: '',
      options: [],
      cityList: [],
      urlAliyunOSS: '/api/XOrg/AssociationIndex/getSign'
    };
  },
  computed: {
    userInfo: function userInfo() {
      return this.$store.state.auth;
    }
  },
  components: {
    imageUpload: imageUpload
  },
  created: function created() {
    this.getInfo();
    this.getAllProvinceList();
  },
  watch: {
    AvatorUrl: function AvatorUrl(val) {
      console.log(val);
    }
  },
  methods: {
    getInfo: function getInfo() {
      var that = this;
      this.$http.post("/api/XOrg/SiteInfo/getSiteInfo", {}).then(function (rst) {
        if (rst.code === 1 && rst.siteInfo) {
          that.userName = rst.siteInfo.userName;
          that.displayName = rst.siteInfo.displayName;
          that.avatorUrl = rst.siteInfo.avatorUrl;
          that.mobile = rst.siteInfo.mobile;
          that.siteTitle = rst.siteInfo.siteTitle;
          that.province = rst.siteInfo.province;
          that.city = rst.siteInfo.city;
          that.InfoCity();
        } else {
          that.$message.warning(rst.msg || '');
        }
      });
    },
    updateSite: function updateSite() {
      var reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;

      if (this.mobile == '') {
        alert("请输入手机号码");
      } else if (!reg.test(this.mobile)) {
        alert("手机格式不正确");
      }

      var that = this;
      this.$http.post("/api/XOrg/SiteInfo/updateSite", {
        siteTitle: that.siteTitle,
        province: that.province,
        city: that.city,
        avatorUrl: that.avatorUrl,
        displayName: that.displayName,
        mobile: that.mobile
      }).then(function (rst) {
        if (rst.code === 1) {
          that.$message.success(rst.msg);
        } else {
          that.$message.warning(rst.msg);
        }
      });
    },
    //获取省市
    getAllProvinceList: function getAllProvinceList() {
      var _this = this;

      this.$http.post("/api/XOrg/AssociationSites/getAllProvinceList", {}).then(function (rst) {
        if (rst.code > 0) {
          _this.options = rst.province;
        }
      });
    },
    getCityList: function getCityList() {
      var that = this;
      this.$http.post("/api/XOrg/AssociationSites/getCityList", {
        province: that.province
      }).then(function (rst) {
        if (rst.code > 0) {
          that.cityList = rst.cityList;
          that.city = rst.cityList.length > 0 ? rst.cityList[0].value : "";
        }
      });
    },
    InfoCity: function InfoCity() {
      var that = this;
      this.$http.post("/api/XOrg/AssociationSites/getCityList", {
        province: that.province
      }).then(function (rst) {
        if (rst.code > 0) {
          that.cityList = rst.cityList;
        }
      });
    }
  }
};